import React from 'react';

export const HeyLogo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="47"
      height="46"
      viewBox="0 0 47 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" width="46" height="46" rx="23" fill="#3D4B41" />
      <path
        d="M28.9406 19.2522C28.8233 19.3714 28.63 19.2898 28.63 19.1225C28.63 18.9697 28.63 18.8013 28.6227 18.6423C28.4419 12.0388 18.5575 12.0388 18.3767 18.6423C18.3725 18.8013 18.3705 18.9614 18.3705 19.1225C18.3705 19.284 18.1742 19.3663 18.0598 19.2522C17.9476 19.1402 17.8313 19.0262 17.7169 18.9174C12.9472 14.3767 5.9624 21.4195 10.4714 26.2114C10.5808 26.3271 10.692 26.4422 10.8049 26.5565C16.2453 32.034 23.4985 32.0345 23.4997 32.0345C23.5009 32.0345 30.7551 32.034 36.1956 26.5565C36.3091 26.4429 36.4203 26.3278 36.529 26.2114C41.038 21.4143 34.0491 14.3767 29.2835 18.9174C29.1682 19.0262 29.0507 19.1382 28.9406 19.2522Z"
        fill="#FFEBB8"
      />
    </svg>
  );
};
